<template>
  <div class="groupProduct">
    <div class="screen">
      <!-- <router-link :to="{ path: '/apply/GoodsGroup/4/createGroup' }"> -->
        <el-button type="primary" size="small" @click="selectIndex = 1">消费验证</el-button>
      <!-- </router-link> -->
      <!-- <router-link :to="{ path: '/apply/GoodsGroup/4/LibraryOfGoods' }"> -->
        <el-button type="primary" size="small" @click="selectIndex = 2">优惠券验证</el-button>
      <!-- </router-link> -->
    </div>
    <template v-if="selectIndex==1">
      <el-tabs v-model="activeName" type="border-card">
        <el-tab-pane label="消费券验证" name="1">
          <div class="tables">
            <template>
              <el-form label-position="top" label-width="80px" :model="formLabelOne" >
                <el-form-item label="选择门店">
                  <el-select v-model="formLabelOne.shop" placeholder="请选择活动区域">
                    <el-option label="区域一" value="shanghai"></el-option>
                    <el-option label="区域二" value="beijing"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="请先验证消费券,再接待">
                  <el-input v-model="formLabelOne.num"></el-input>
                  <el-button type="primary">优惠券验证</el-button>
                </el-form-item>
              </el-form>
            </template>
          </div>
        </el-tab-pane>
        <el-tab-pane label="消费券批量验证" name="2">
          <div class="tables">
            <template>
              <el-form label-position="top" label-width="80px" :model="formLabeltwo" >
                <el-form-item label="选择门店">
                  <el-select v-model="formLabeltwo.shop" placeholder="请选择活动区域">
                    <el-option label="区域一" value="shanghai"></el-option>
                    <el-option label="区域二" value="beijing"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="请先验证消费券,再接待">
                  <el-input v-model="formLabeltwo.num1" placeholder="请输入验证码" class="marginbtm15"></el-input></br>
                  <el-input v-model="formLabeltwo.num2" placeholder="请输入验证码" class="marginbtm15"></el-input></br>
                  <el-input v-model="formLabeltwo.num3" placeholder="请输入验证码" class="marginbtm15"></el-input></br>
                  <el-input v-model="formLabeltwo.num4" placeholder="请输入验证码" class="marginbtm15"></el-input></br>
                  <el-input v-model="formLabeltwo.num5" placeholder="请输入验证码" class="marginbtm15"></el-input></br>
                  <el-button type="primary">优惠券验证</el-button>
                </el-form-item>
              </el-form>
            </template>
          </div>
        </el-tab-pane>
        <el-tab-pane label="超级验证" name="3">
          <div class="tables">
            <template>
              <el-form label-position="top" label-width="80px" :model="formLabelThree" >
                <el-form-item label="选择门店">
                  <el-select v-model="formLabelThree.shop" placeholder="请选择活动区域">
                    <el-option label="区域一" value="shanghai"></el-option>
                    <el-option label="区域二" value="beijing"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="请先验证消费券,再接待">
                  <el-input v-model="formLabelThree.num"></el-input>
                  <el-button type="primary">优惠券验证</el-button>
                </el-form-item>
              </el-form>
            </template>
            <div class="hint">
              <h3>温馨提示</h3>
              <p class="hintCont">超级验证，输入其中一个密码可以查询出该订单下的所有可用消费券</p>
              <p class="hintCont">超级验证，输入其中一个密码可以查询出该订单下的所有可用消费券</p>
            </div>
          </div>
        </el-tab-pane>

      </el-tabs>
    </template>
    <template v-else>
      <h2>消费券验证与消费</h2>
      <div class="tables">
       <el-form label-position="top" label-width="80px" :model="formLabelThree" >
                <el-form-item label="选择门店">
                  <el-select v-model="formLabelThree.shop" placeholder="请选择活动区域">
                    <el-option label="区域一" value="shanghai"></el-option>
                    <el-option label="区域二" value="beijing"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="请输入优惠券序列号进行验证消费">
                  <el-input v-model="formLabelThree.num"></el-input>
                  <el-button type="primary">优惠券验证</el-button>
                </el-form-item>
              </el-form>
              </div>
    </template> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectIndex: 1,
      formLabelOne: {
          shop: '',
          num: ''
        },
        formLabeltwo: {
          shop: '',
          num1: '',
          num2: '',
          num3: '',
          num4: '',
          num5: '',
        },
        formLabelThree: {
          shop: '',
          num: ''
        },
        formLabelyhj: {
          shop: '',
          num: ''
        },
      activeName: "1",
      tableData: [],
      value: ""
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.groupProduct {
  width: 100%;
  padding: 15px 25px;
  height: 100%;
  overflow: auto;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
  .el-input {
      width: 60%;
    }
  .screen {
    display: flex;
    flex-direction: row;
    margin-bottom: 25px;
    .el-button,
    .el-select,
    .el-input {
      margin-right: 10px;
    }
  }
  .tables {
    width: 40%;
    .marginbtm15 {
      margin-bottom: 15px;
    }
  }
  .hint {
    opacity: 0.7;
    width: 100%;
    height: 120px;
    background: #eb80111f;
    border: 1px solid #eb8011;
    padding: 10px;
    .hintCont {
      padding-left: 30px;
      margin-top: 10px;
    }
  }
}
</style>

<style lang="scss">
.groupProduct {
  .cell {
    text-align: center;
  }
}
</style>
